import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface INominationStatusFilterSelectProps {
    value: string[];
    onChange: (value: string[]) => void;
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    options: ISelectOption<string>[];
}

export const NominationStatusFilterSelect: React.FC<INominationStatusFilterSelectProps> = ({
    value,
    onChange,
    label,
    height = 220,
    disabled = false,
    options,
}) => {
    return (
        <BaseFilterCheckboxSelect
            multiple
            resizable={false}
            showClear
            showSelectAllOption={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            height={height}
        />
    );
};
